import React, { useEffect } from "react";
import Navbar from "./Navbar";
import ForestPath from "./ForestPath";
import Hero from "./Hero";
import Espectacles from "./Espectacles";
import Valors from "./Valors";
import QuiSom from "./QuiSom";
import Contacte from "./Contacte";
import Footer from "./Footer";
import MonkeyComplete from "./MonkeyComplete";
import MonkeyHint from "./MonkeyHint";
import { setCanonical, setMetaDescription } from "./seo";

export default function Home() {
  useEffect(() => {
    document.title = "Karamiko · Teatre infantil a Lleida per a escoles i famílies";
    setCanonical("https://karamiko.cat/");
    setMetaDescription(
      "Karamiko, teatre infantil a Lleida. Companyia de teatre artesanal i feminista en català: espectacles i tallers per a escoles, biblioteques i famílies."
    );
  }, []);

  return (
    <>
      <Navbar />
      <ForestPath />
      <main>
        <Hero />
        <Espectacles />
        <Valors />
        <QuiSom />
        <Contacte />
      </main>
      <Footer />
      <MonkeyComplete />
      <MonkeyHint />
    </>
  );
}
